import { ErrorResponse } from "@apollo/client/link/error";

export function hasErrorCode(
  errors: ErrorResponse["graphQLErrors"],
  code: string
) {
  if (!errors) {
    return false;
  }

  for (const e of errors) {
    // TODO: get API to send error code in "extensions" field
    if ((e as any).code === code) {
      return true;
    }
  }

  return false;
}

export function getError(errors: ErrorResponse["graphQLErrors"]): Error | null {
  if (!errors) {
    return null;
  }

  let message = "";

  for (const e of errors) {
    // TODO: get API to send error code in "extensions" field
    if (typeof (e as any).code === "string") {
      return new Error(`${(e as any).code} - ${e.message}`);
    }
    message = e.message;
  }

  return new Error(message || "Unknown GraphQL error");
}
